import { useLayoutEffect } from 'react';

const TOASTIFY_SELECTOR = '.Toastify';

export const usePreventOutsideClickOnToast = () => {
  useLayoutEffect(() => {
    const handler = (e: MouseEvent) => {
      if (e.target instanceof Element && e.target.closest(TOASTIFY_SELECTOR)) {
        e.stopImmediatePropagation();
      }
    };
    window.addEventListener('mousedown', handler, true);
    return () => window.removeEventListener('mousedown', handler, true);
  }, []);
};
